import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { ArtikelGroupFilterSettings } from '../entities/articles/artikelgroupfiltersettings.entity';
import { ArtikelGroup } from '../entities/articles/artikelgroup.entity';
import { Asset } from '../entities/assets/asset.entity';
import { Artikel } from '../entities/artikel.entity';
import { Group } from '../entities/schema/group.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
import { AssetViewDto } from '../Mza/Service/Models/assetviewdto.entity';
//#endregion

@Injectable()
export class ArtikelGroupService extends ODataEntityService<ArtikelGroup> {
  constructor(protected client: ODataClient) {
    super(client, 'ArtikelGroup', 'entities.articles.ArtikelGroup');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  public getAssets(): ODataFunctionResource<{groupId: number}, AssetViewDto> {
    const resource = this.entities().function<{groupId: number}, AssetViewDto>('services.GetAssets');
    return resource;
  }
  //#endregion
  //#region ODataApi Navigations
  public artikel(entity: EntityKey<ArtikelGroup>): ODataNavigationPropertyResource<Artikel> {
    return this.entity(entity).navigationProperty<Artikel>('artikel');
  }
  public artikelGroupFilterSettings(entity: EntityKey<ArtikelGroup>): ODataNavigationPropertyResource<ArtikelGroupFilterSettings> {
    return this.entity(entity).navigationProperty<ArtikelGroupFilterSettings>('artikelGroupFilterSettings');
  }
  public group(entity: EntityKey<ArtikelGroup>): ODataNavigationPropertyResource<Group> {
    return this.entity(entity).navigationProperty<Group>('group');
  }
  public status(entity: EntityKey<ArtikelGroup>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<ArtikelGroup>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
